import { autoAffix } from 'utils/wrappers';

import Base from 'app/views/base';

import tmpl from 'templates/empty';

// TODO: header height + padding + 1 (see scaffolding.scss: .has-fixed-header :target:before)
export const SCROLLSPY_FIXED_HEADER_OFFSET = 65;

export default Base.extend({
  compiledTemplate: tmpl,

  events: {},

  initialize() {
    $('body').scrollspy({
      target: '.scrollnav',
      offset: SCROLLSPY_FIXED_HEADER_OFFSET,
    });
    autoAffix();
  },
});



// WEBPACK FOOTER //
// ./app/views/scrollspy_page.js